import React from 'react';

const wrapStyle = {
  background: '#fff',
  borderRadius: 10,
  border: '1px solid #e5e7eb',
  padding: 18,
};

const titleStyle = {
  margin: 0,
  color: '#1f2a44',
  fontSize: 24,
  fontWeight: 700,
};

const subtitleStyle = {
  marginTop: 8,
  marginBottom: 16,
  color: '#6b7280',
  fontSize: 14,
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

const thStyle = {
  textAlign: 'left',
  padding: '10px 12px',
  borderBottom: '1px solid #e5e7eb',
  color: '#374151',
  fontWeight: 600,
  fontSize: 13,
};

const tdStyle = {
  padding: '10px 12px',
  borderBottom: '1px solid #f3f4f6',
  color: '#111827',
  fontSize: 13,
};

export default function ActivityPlaceholderTable({ title, subtitle, columns = [], rows = [] }) {
  return (
    <div style={wrapStyle}>
      <h2 style={titleStyle}>{title}</h2>
      <p style={subtitleStyle}>{subtitle}</p>
      <table style={tableStyle}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col} style={thStyle}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={`${title}-row-${idx}`}>
              {row.map((cell, cellIdx) => (
                <td key={`${title}-row-${idx}-col-${cellIdx}`} style={tdStyle}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

